import { getThemeColors } from '@/lib/theme-colors';

export function getVariableColors() {
  const c = getThemeColors();
  return [c.purple50, c.blue50, c.teal50, c.red50, c.orange50, c.green50];
}

export function getVariableAlternateColors() {
  const c = getThemeColors();
  return [c.purple20, c.blue20, c.teal20, c.red20, c.orange20, c.green20];
}

// Static exports for backward compatibility (dark mode values)
// Prefer getVariableColors()/getVariableAlternateColors() for theme-aware usage
export const variableColors = getVariableColors();
export const variableAlternateColors = getVariableAlternateColors();
